import { initializeSwiperHero } from './product-swiper-hero'
import { initializeSwiperProdViews } from './product-swiper-prod-views'

export const initializeSwiperHeroAndViews = () => {
  const hero = initializeSwiperHero()
  const prodViews = initializeSwiperProdViews()
  if (hero && prodViews) {
    // Connect both instances so they can control each other
    hero.controller.control = prodViews
    prodViews.controller.control = hero
  }
}
